// extracted by mini-css-extract-plugin
export default {"legendaMapa":"Legenda_legendaMapa__QK+Yx"};